
export const SIGN_IN = 'sign-in'

export const AUTH_PUBLIC_ROUTE = [
    SIGN_IN
]